import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import cn from 'classnames';
import Button from 'chameleon/ui-stack/ui/base/button';
import { createClassRedirect } from './utils';
import './NoClassAlert.scss';

class NoClassAlert extends Component {
  static displayName = 'NoClassAlert';

  static propTypes = {
    params: PropTypes.object.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    withMargin: PropTypes.bool,
    withPadding: PropTypes.bool,
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    className: PropTypes.string,
    descriptionClassName: PropTypes.string,
    contentClassName: PropTypes.string,
  };

  static defaultProps = {
    withMargin: false,
    withPadding: true,
    title: 'Create a Class',
    content: '',
    description: null,
    className: '',
    descriptionClassName: '',
    contentClassName: '',
  };

  onCreateClassClick = () => {
    const {
      params: { subject },
      router,
    } = this.props;
    createClassRedirect(subject, router);
  };

  render() {
    const {
      withMargin,
      withPadding,
      title,
      content,
      description,
      userData,
      subjectData,
      className,
      descriptionClassName,
      contentClassName,
    } = this.props;
    const {
      data: { isPreApSubject },
    } = subjectData;
    const {
      isAdmin,
      isCoordinator,
      isContentExpiring,
      isContentExpired,
      isNewContentAvailable,
    } = userData;

    if (isAdmin || isCoordinator) {
      return null;
    }

    const APcontent = (
      <div className="NoClasses--text">
        <div className="NoClasses--text--bold">
          Just click the button to create a section for each class you teach.
        </div>
        Get started using AP Classroom resources with your students, and enable
        them to register for the AP Exam.
      </div>
    );

    const PreAPContent = (
      <div className="NoClasses--text">
        <span className="NoClasses--text--bold">
          Click the button to the right to create your classes.
        </span>
      </div>
    );

    if (
      (isContentExpiring === true ||
        isContentExpired === true ||
        isNewContentAvailable === true) &&
      isPreApSubject
    ) {
      // When we are right before or past the expiration of an academic year, there's no value to creating
      // a class. It'll just disappear again in a couple weeks. So, hide the Create A Class banner
      // when that's the case.
      return null;
    }

    const contentDescription =
      content || (isPreApSubject && PreAPContent) || APcontent;

    return (
      <div
        className={cn(
          className || `createClassContainer${withMargin ? '--margin' : ''}`,
          {
            'createClassContainer--padding': withPadding,
          },
        )}
      >
        {title && <div className="CreateClassTitle">{title}</div>}
        {description && (
          <div className={`description ${descriptionClassName}`}>
            {description}
          </div>
        )}
        <div className={`NoClasses p-8.4 pt-8.8 ${contentClassName}`}>
          {contentDescription}
          <div>
            <Button
              isPrimary
              className="whitespace-nowrap"
              aria-label="Create a Class Section"
              tabIndex="0"
              onClick={this.onCreateClassClick}
            >
              Create a Class Section
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userData: state.userData,
    subjectData: state.subject,
  };
}

export default connect(mapStateToProps)(withRouter(NoClassAlert));
